import { Header } from "./container/header/header";
import Page from "./container/menu/Page"
import React,{useState, useEffect} from 'react';
import "./layout.css";

export const Layout = () => {
  const [toggleSideNav,setSideNav] = useState(false);
  
  // Close sidenav when screen is mobile
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1045) {
        setSideNav(true);
      }
    };
    
    // Call once on mount
    handleResize();
    
    // Add resize listener
    window.addEventListener('resize', handleResize);
    
    // Listen for close sidenav event
    const handleCloseSideNav = () => {
      setSideNav(true);
    };
    window.addEventListener('closeSideNav', handleCloseSideNav);
    
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('closeSideNav', handleCloseSideNav);
    };
  }, []);

  const handleToggle = () => {
    setSideNav(!toggleSideNav);
  };

  return (
    <div className="layout-container">
      {/* Need to work on css of header in mobile screens */}
      <Header toggleSideNav={handleToggle}/>
      <div className="layout-content">
        <Page toggleFlag={toggleSideNav}/>
      </div>
    </div>
  );
};
